import React from 'react';
import { PRODUCT_TYPES } from '../../../constants';

const ProductTableHeader = React.memo(({ 
  activeTypeTab, 
  filteredProductsCount, 
  isAdmin, 
  isSatisci, 
  isMontajci, 
  isYazilimci,
  isExcelLoading,
  isLoading,
  onRefresh,
  fileInputRef, 
  handleImportExcel, 
  handleImportClick, 
  handleExportExcel, 
  handleClearList 
}) => {
  return (
    <div className="product-table-header-bar">
      <div className="product-table-title">
        <i className="fas fa-list"></i>
        <span>{PRODUCT_TYPES[activeTypeTab]?.label} Ürünleri</span>
        <span className="product-count">({filteredProductsCount} ürün)</span>
      </div>
      {(isAdmin || isSatisci || isYazilimci) && !isMontajci && (
        <div className="excel-actions">
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".xlsx, .xls, .csv"
            onChange={handleImportExcel}
          />
          <button
            className="btn-excel btn-import"
            onClick={handleImportClick}
            disabled={isExcelLoading}
          >
            {isExcelLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-file-import"></i>} Excel'den Yükle
          </button>
          <button
            className="btn-excel btn-export"
            onClick={handleExportExcel}
            disabled={filteredProductsCount === 0 || isExcelLoading}
          >
            <i className="fas fa-file-export"></i> Excel'e Aktar
          </button>
          <button
            className="btn-excel btn-clear-list"
            onClick={handleClearList}
            disabled={isExcelLoading}
            title="Bu kategorideki tüm ürünleri sil"
          >
            <i className="fas fa-trash-alt"></i> Listeyi Temizle
          </button>
          <button
            className="btn-refresh-products"
            onClick={onRefresh}
            disabled={isLoading || isExcelLoading}
            title="Listeyi yenile"
          >
            <i className={`fas fa-sync-alt ${isLoading ? 'fa-spin' : ''}`}></i>
          </button>
        </div>
      )}
    </div>
  );
});

export default ProductTableHeader;
